import { TriangleAlert } from "lucide-react";
import type { BlockContentMap } from "@veo/types";
import { cn } from "@veo/ui";
import { RichText } from "../components/RichText";
import { SectionShell, type SectionProps } from "./SectionRenderer";

const VARIANTS: Record<string, string> = {
  subtle: "bg-ink-50 text-ink-600",
  bordered: "border border-gold-300 bg-gold-50 text-ink-700",
  prominent: "border-2 border-gold-500 bg-gold-50 text-ink-800",
};

export default function RiskDisclaimerBlock({
  content,
  settings,
}: SectionProps<BlockContentMap["riskDisclaimer"]>) {
  return (
    <SectionShell settings={settings}>
      <div
        className={cn(
          "mx-auto max-w-3xl rounded-lg p-6",
          VARIANTS[content.variant] ?? VARIANTS.bordered,
        )}
      >
        <h2 className="flex items-center gap-2 font-display text-lg text-navy-900">
          {content.icon && <TriangleAlert aria-hidden className="size-5 shrink-0 text-gold-600" />}
          {content.heading}
        </h2>
        <div className="mt-3 text-sm [&_p]:text-sm">
          <RichText doc={content.body} />
        </div>
      </div>
    </SectionShell>
  );
}
